import React, { useState } from "react";
import "./Auth.css";
import Login from "./Login";
import logo from "../../assets/dhanushdhari_final_log.jpeg";
import { useNavigate } from "react-router-dom";
import { RegisterUser } from "../../Services/Operations/ProductAPI";

const AuthPage = () => {

  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();
  const [full_name,setFullName]=useState('')
  const [email,setEmail]=useState("")
  const [phone,setPhone]=useState("")
  const [birth_date,setBirthDate]=useState("")
  const[password,setPassword]=useState("")
  const[password_confirmation,setPasswordConfirmation]=useState("")

  const handleRegister=async()=>{
    try {
      if(password!==password_confirmation){
        alert("Password confirmation is wrong")
        return
      }
      let data={
        full_name,email,phone,birth_date,password,password_confirmation
      }
      const res= await RegisterUser(data)
      console.log(res);
      setIsLogin(false)
      
    } catch (error) {
      console.log(error);
      
    }
  }

  return (
    <div className="dd-auth-wrapper">

      {/* BACK BUTTON */}
      <button
        className="dd-back-btn"
        onClick={() => navigate('/')}
      >
        ← Back
      </button>

      {/* LOGO */}
      <div className="dd-auth-logo">
        <div className="dd-logo-shape">
          <img src={logo} alt="Logo" height="90" width="90" />
        </div>
      </div>

      {/* LOGIN REGISTER SWITCH */}
      <div className="dd-auth-switch">

        <button
          className={`dd-btn-outline ${isLogin ? "active" : "inactive"}`}
          onClick={() => setIsLogin(true)}
        >
          Login
        </button>

        <button
          className={`dd-btn-primary ${!isLogin ? "active" : "inactive"}`}
          onClick={() => setIsLogin(false)}
        >
          Register
        </button>

      </div>

      {/* CARD */}
      <div className="dd-auth-card">

        {isLogin ? (
          <Login />
        ) : (
          <>
            <h2>Welcome</h2>

            <p className="dd-auth-subtitle">
              Enter your credentials to access your account
            </p>

            <form className="dd-auth-form">

              <label>Full Name *</label>
              <input type="text" placeholder="Enter your full name"
              value={full_name} onChange={(e)=>setFullName(e.target.value)} />

              <label>Phone Number *</label>
              <input type="number" placeholder="Enter your phone number"
               value={phone} onChange={(e)=>setPhone(e.target.value)} />

              <label>Email *</label>
              <input type="email" placeholder="Enter your email" 
               value={email} onChange={(e)=>setEmail(e.target.value)}/>

              <label>Birth Date</label>
              <input type="date" 
               value={birth_date} onChange={(e)=>setBirthDate(e.target.value)}/>

              <label>Password *</label>
              <input type="password" placeholder="Enter your password" 
               value={password} onChange={(e)=>setPassword(e.target.value)}/>
               <label>Confirm Password *</label>
              <input type="password" placeholder="Enter your password" 
               value={password_confirmation} onChange={(e)=>setPasswordConfirmation(e.target.value)}/>

              <div className="dd-remember">
                <input type="checkbox" />
                <span>Remember Me</span>
              </div>

              <button className="dd-auth-submit"
              onClick={()=>handleRegister()}>Register</button>

              <p className="dd-auth-divider">Or Continue With</p>

              <div className="dd-social-buttons">
                <button>Google</button>
                <button>Facebook</button>
              </div>

              <p className="dd-auth-terms">
                By continuing, you agree to our Terms of Service and Privacy Policy
              </p>

            </form>
          </>
        )}

      </div>

    </div>
  );
};

export default AuthPage;